import Reflux from 'reflux';

export default Reflux.createActions([
  'scrub',
  'selectLanguage',
  'playlistNavigate',
  'chapter',
  'slideNavigate',
  'slideZoom',
  'slideThumb',
  'slideSelect',
  'closedCaption',
  'playList'
]);



// WEBPACK FOOTER //
// ./modules/actions/cme_tracking_actions.js